module.exports = __webpack_public_path__ + "img/04.63d5eb22.png";